export interface outputDataType {
	id: number;
	system: string;
	nrwg: string;
	windowQuantity: number;
	dimension: string;
	louvre: string;
	ug: number;
	psi: number;
	aGeoTotal: number;
	aAeroTotal: number;
	uw: string;
}

export interface UgAgPsiTotal {
	ugTimesAg: number;
	piTimesLg: number;
	totalUfAf: number;
	totalUfAfWithIso: number;
}

export interface areaFLL {
	profileTop: {
		withIso: number,
		noIso: number
	},
	louvreShock: {
		withIso: number,
		noIso: number
	},
	profileBottom: {
		withIso:number,
		noIso: number
	},
	profileSide: {
		withIso: number,
		noIso: number
	},
	middleMullion: {
		withIso: number,
		noIso: number
	},
};

export interface areaFLLPsi {
	profileTopPsi: {
		withIso: number,
		noIso: number
	},
	louvreShockPsi: {
		withIso: number,
		noIso: number
	},
	profileBottomPsi: {
		withIso:number,
		noIso: number
	},
	profileSidePsi: {
		withIso: number,
		noIso: number
	},
	middleMullionPsi: {
		withIso: number,
		noIso: number
	}
}

export interface areaFLLPsiTotalAw {
	total: {
		withIso: number,
		noIso: number
	},
	awUp: {
		withIso: number,
		noIso: number
	}
}


export interface area {
	top: number,
	bottom: number,
	sideNoTop: number,
	sideNoBottom: number,
	louvre: number,
	louvreAll: number,
	uf: {
		noIsolation: { top: number, bottom: number, side: number, louvre: number }
		isolation: { top: number, bottom: number, side: number, louvre: number }
	}
};

export interface louvreArea {
	aw: number;
	af: number;
	ag: number;
	lg: number;
	louvreArea: number;
}

export interface productValuesType {
	defaultValues: {
		height: number,
		width: number,
		windowQuantity: number
		ug: {
			glass2: number,
			glass3: number,
			panel: number
		},
		psi: {
			glass2: number,
			glass3: number,
			panel: number
		}
		isolation: boolean,
		glassThickness: number,
		glassTypes: number,
		middleMullion: boolean
	},
	fixedValues: {
		glass: Array<{name: string, value: number}>,
		glassTypes: Array<{name: string, value: number}>,
		ug2: Array<{value: number}>,
		ug3: Array<{value: number}>,
		up: Array<{name: string, value: number}>,
		psi: {
			ug2:Array<{name: string, value: number}>,
			ug3:Array<{name: string, value: number}>,
			up:Array<{name: string, value: number}>,
		},
		middleMullion: boolean,
		isolation: boolean,
	},
	cvReference85deg: number,
	cvFactors: { cv1: number, cv2: number, cv3: number},
	soundIsolation: {
		twoFolds: string,
		threeFolds: string
	},
	dimensionsOpenLouvre: {
		sideMullion: number,
		profileTop: number,
		profileBottom: number,
		louvre: number,
		mm: number
	},
	area: {},
	windLoadCalculation: {
		wl1000: [
			{
				wMax: number,
				hMax: number,
				aMax: number
			},
			{
				wMax: number,
				hMax: number,
				aMax: number
			}
		],
		wl1100: [
			{
				wMax: number,
				hMax: number,
				aMax: number
			},
			{
				wMax: number,
				hMax: number,
				aMax: number
			}
		],
		wl1250: [
			{
				wMax: number,
				hMax: number,
				aMax: number
			},
			{
				wMax: number,
				hMax: number,
				aMax: number
			}
		],
		wl1500: [
			{
				wMax: number,
				hMax: number,
				aMax: number
			},
			{
				wMax: number,
				hMax: number,
				aMax: number
			}
		],
		wl1750: [
			{
				wMax: number,
				hMax: number,
				aMax: number
			},
			{
				wMax: number,
				hMax: number,
				aMax: number
			}
		],
		wl2000: [
			{
				wMax: number,
				hMax: number,
				aMax: number
			},
			{
				wMax: number,
				hMax: number,
				aMax: number
			}
		],
		wl2250: [
			{
				wMax: number,
				hMax: number,
				aMax: number
			},
			{
				wMax: number,
				hMax: number,
				aMax: number
			}
		],
		wl2500: [
			{
				wMax: number,
				hMax: number,
				aMax: number
			},
			{
				wMax: number,
				hMax: number,
				aMax: number
			}
		],
		wl2750: [
			{
				wMax: number,
				hMax: number,
				aMax: number
			},
			{
				wMax: number,
				hMax: number,
				aMax: number
			}
		],
		wl2900: [
			{
				wMax: number,
				hMax: number,
				aMax: number
			},
			{
				wMax: number,
				hMax: number,
				aMax: number
			}
		],
		wl3000: [
			{
				wMax: number,
				hMax: number,
				aMax: number
			},
			{
				wMax: number,
				hMax: number,
				aMax: number
			}
		],
	},
	edgeTop: {
		W_m2K: number,
		W_m2K_iso: number,
		width: number
	},
	edgeSide: {
		W_m2K: number,
		W_m2K_iso: number,
		width: number
	},
	edgeBottom: {
		W_m2K: number,
		W_m2K_iso: number,
		width: number
	},
	louvre: {
		W_m2K: number,
		W_m2K_iso: number,
		width: number
	},
	middleMullion: {
		W_m2K: number,
		width: number,
		min: number,
		max: number
	},
	windowWidth: {
		min: number,
		max: number
		nrwgMax: number
	},
	windowWidthWithMM: {
		min: number,
		max: number
	},
	windowHeight: {
		min: number,
		max: number
	},
	louvreHeight: {
		min: number,
		max: number
	},
	gabDimensions: {
		side: number,
		top: number,
		middle: number,
		bottom: number,
		mm: number
	},
	edgeWidth: number,
	allowance: {
		width: number,
		height: number
	}

}
